export namespace CacheDataActions {
  export class SetCachedData {
    static readonly type = '[CacheData] Set Cached Data';

    constructor(
      public key: string,
      public data: any,
      public criteria: any
    ) {}
  }

  export class ClearCachedData {
    static readonly type = '[CacheData] Clear Cached Data';

    constructor(public key: string) {}
  }

  export class InvalidateCache {
    static readonly type = '[CacheData] Invalidate cache';

    constructor(public key: string) {}
  }
}
